'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var varint = require('varint');

var BufferList = require('bl/BufferList');

var POOL_SIZE = 10 * 1024;

var Encoder = /*#__PURE__*/function () {
  function Encoder() {
    _classCallCheck(this, Encoder);

    this._pool = Buffer.allocUnsafe(POOL_SIZE);
    this._poolOffset = 0;
  }
  /**
   * Encodes the given message and returns it and its header
   * @param {*} msg The message object to encode
   * @returns {Buffer|Buffer[]}
   */


  _createClass(Encoder, [{
    key: "write",
    value: function write(msg) {
      var pool = this._pool;
      var offset = this._poolOffset;
      varint.encode(msg.id << 3 | msg.type, pool, offset);
      offset += varint.encode.bytes;
      varint.encode(msg.data ? msg.data.length : 0, pool, offset);
      offset += varint.encode.bytes;
      var header = pool.slice(this._poolOffset, offset);

      if (POOL_SIZE - offset < 100) {
        this._pool = Buffer.allocUnsafe(POOL_SIZE);
        this._poolOffset = 0;
      } else {
        this._poolOffset = offset;
      }

      if (!msg.data) return header;
      return [header, msg.data];
    }
  }]);

  return Encoder;
}();

var encoder = new Encoder(); // Encode one or more messages and yield a BufferList of encoded messages

module.exports = function (source) {
  return function () {
    var _encode = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, msg;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context.next = 6;
              return _awaitAsyncGenerator(_iterator.next());

            case 6:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 10;
              return _awaitAsyncGenerator(_step.value);

            case 10:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 23;
                break;
              }

              msg = _value;

              if (!Array.isArray(msg)) {
                _context.next = 18;
                break;
              }

              _context.next = 16;
              return new BufferList(msg.map(function (m) {
                return encoder.write(m);
              }));

            case 16:
              _context.next = 20;
              break;

            case 18:
              _context.next = 20;
              return new BufferList(encoder.write(msg));

            case 20:
              _iteratorNormalCompletion = true;
              _context.next = 4;
              break;

            case 23:
              _context.next = 29;
              break;

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 29:
              _context.prev = 29;
              _context.prev = 30;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 34;
                break;
              }

              _context.next = 34;
              return _awaitAsyncGenerator(_iterator.return());

            case 34:
              _context.prev = 34;

              if (!_didIteratorError) {
                _context.next = 37;
                break;
              }

              throw _iteratorError;

            case 37:
              return _context.finish(34);

            case 38:
              return _context.finish(29);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 25, 29, 39], [30,, 34, 38]]);
    }));

    function encode() {
      return _encode.apply(this, arguments);
    }

    return encode;
  }()();
};